import { createFileRoute } from '@tanstack/react-router';
import { SeoOverviewPage } from '@/pages/SeoOverviewPage';

// Индекс-роут /seo (Обзор). Важно: НЕ _authed.seo.tsx — иначе он стал бы родителем
// с компонентом без <Outlet/> и дочерние /seo/* не рендерились бы (показывался Обзор).
export const Route = createFileRoute('/_authed/seo/')({
  component: SeoOverviewPage,
});
